import { render, staticRenderFns } from "./IconPlus.vue?vue&type=template&id=1c9fac88&scoped=true&"
import script from "./IconPlus.vue?vue&type=script&lang=js&"
export * from "./IconPlus.vue?vue&type=script&lang=js&"
import style0 from "./IconPlus.vue?vue&type=style&index=0&id=1c9fac88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9fac88",
  null
  
)

export default component.exports